exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ContactList {\n  margin-top: -15px; }\n  .ContactList .ListField-Content {\n    display: flex;\n    flex-flow: row wrap; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./client/RLX/Forms/ContactList/ContactList.scss
// module id = 389
// module chunks = 0